export const fonts = {
    primary: 'Montserrat',
    secondary: 'Libre Franklin'
}
